import Dialog from "@components/Dialog/Dialog"
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Box, Typography, useTheme } from "@mui/material"

interface DeleteVerificationQuestionDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
}

const DeleteVerificationQuestionDialog = ({
  open,
  onClose,
  onDelete
}: DeleteVerificationQuestionDialogProps) => {
  const theme = useTheme();

  return <>
    <Dialog
      open={open}
      onClose={onClose}
      primaryButtonAction={onDelete}
      primaryButtonText="Delete"
      fullWidth={false}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: "center",
          padding: 2,
        }}
      >
        <WarningAmberIcon sx={{ fontSize: 32, color: theme.palette.error.light }} />

        <Typography
          variant="body1"
          sx={{ marginTop: 2 }}
        >
          Are you sure you want to delete the additional question?
        </Typography>
      </Box>
    </Dialog>

  </>
}

export default DeleteVerificationQuestionDialog